import Hero from './Hero'

const AboutView = () => {
    return (
      <>
        <Hero text="About Us "/>
        <div className="container my-5">
          <div className="row align-items-center">
            {/* Bagian teks */}
            <div className="col-lg-8 col-12">
              <div className="bg-light rounded shadow-sm p-4">
                <p className="lead mb-0">
                  <strong>Kakilima</strong> adalah sebuah aplikasi inovatif berbasis web dan mobile yang dirancang khusus untuk membantu pengguna menemukan pedagang kaki lima favorit mereka dengan cepat, mudah, dan akurat. 
                  Aplikasi ini hadir sebagai solusi atas tantangan yang dihadapi masyarakat dalam melacak keberadaan para pedagang yang kerap berpindah-pindah tempat dan tidak memiliki lokasi usaha yang tetap.
                </p>
                <hr />
                <p className="mb-0">
                  Melalui pemetaan lokasi secara real-time, Kakilima memungkinkan pengguna untuk mengetahui posisi terkini para penjual makanan, minuman, dan jajanan tradisional yang tersebar di berbagai sudut kota. 
                  Dengan fitur pencarian yang intuitif dan tampilan antarmuka yang ramah pengguna, Kakilima menjembatani kebutuhan masyarakat terhadap kuliner lokal yang autentik, sekaligus membantu meningkatkan visibilitas dan pendapatan para pelaku usaha kecil di sektor informal.
                </p>
                <p className="mt-3 mb-0">
                  Dengan Kakilima, pengalaman berburu kuliner kaki lima menjadi lebih menyenangkan, efisien, dan terarah—tidak perlu lagi bertanya-tanya <em>“di mana penjual favorit saya hari ini?”</em>
                </p>
              </div>
            </div>

            {/* Bagian gambar */}
            <div className="col-lg-4 col-12 mt-4 mt-lg-0">
              <div className="card mb-3 shadow-sm">
                <img 
                  src="https://kakilima.antha.my.id/storage/images/4wI5wqnXZ2JC2FKNqBBgWiXS7PbA9xA1X4P4cIAa.jpg" 
                  alt="Pedagang kaki lima" 
                  className="card-img-top rounded" 
                />
              </div>
              <div className="card shadow-sm">
                <img 
                  src="https://kakilima.antha.my.id/storage/images/eKsInG5RQX8fwkVHupjdFlHyxjhTvG8uiqLJpdxq.jpg" 
                  alt="Kuliner kaki lima" 
                  className="card-img-top rounded" 
                />
              </div>
            </div>
          </div>
        </div>
      </>
    )
  }

  
  export default AboutView